import { render, staticRenderFns } from "./workout-by-slider-category.vue?vue&type=template&id=6b39feb2&"
import script from "./workout-by-slider-category.vue?vue&type=script&lang=js&"
export * from "./workout-by-slider-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports